export default "__VITE_ASSET__QNG_NBGw__"